import { createAction } from 'redux-starter-kit';
import { get, post } from '../../../../utility/via-fetch';
import { requestStart, requestFailed, requestSucceded } from '../../../domain/requests/RequestActions';
import { addMessage } from '../../application/messageUiActions';
import { putVideoOptions } from '../../../domain/videoOption/videoOptionActions';
import { putAppConfig } from '../../../domain/appConfig/appConfigActions';
import routeLocations from '../../../../utility/route-locations';
import viaIntl from '../../../../contexts/via-intl';


/**
 * An action that signifies a request to load video options has been made.
 * @example dispatch(fetchVideoOptions())
 */
export const fetchVideoOptionsPageData = createAction('FETCH_VIDEO_OPTIONS_PAGE_DATA');

/**
 * An action for loading all the data for the video options page.
 * @example dispatch(requestVideoOptionsPageData())
 */
export function requestVideoOptionsPageData() {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchVideoOptionsPageData.toString()));
    dispatch(fetchVideoOptionsPageData(requestId));

    try {
      const [videoOptions, appConfig] = await Promise.all([get('/api/mobile-configuration/'), get('/api/application-configurations/VIDEOS_ALLOWED_MAX_RANGE')]);
      // Normalise data. Store the data in the domain, and the ids in the request response.
      dispatch(putVideoOptions(videoOptions));
      dispatch(putAppConfig(appConfig));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

/**
 * An action that signifies that a fetch to update a video option
 * has been made in the video option configuration screen.
 * This should pass through the request id.
 * @example dispatch(requestUpdateVideoOption(requestId));
 */
export const fetchUpdateVideoOptions = createAction('FETCH_UPDATE_VIDEO_OPTIONS');

export function requestUpdateVideoOptions(videoOptions, history, wizard, wizardNext) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart());
    dispatch(fetchUpdateVideoOptions(requestId));
    try {
      await post('/api/mobile-configuration/', {}, videoOptions);
      dispatch(putVideoOptions(videoOptions));
      dispatch(requestSucceded(requestId));

      // Next wizard or go back to the read only screen
      if (wizard) {
        wizardNext();
      } else {
        history.push(routeLocations.configure_video_options);
      }

      const { intl } = viaIntl;
      dispatch(addMessage('success', 'itemUpdated', { item: intl.formatMessage({ id: 'videoOptions' }) }));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}
